import './style.scss';

export function specialists_cta_block() {
    const block = document.querySelector('.specialists_cta_block');
    if (!block) return;
}

